import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BsModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

@Component({
  selector: 'app-new-contract-status',
  templateUrl: './new-contract-status.component.html',
  styleUrls: ['./new-contract-status.component.css']
})
export class NewContractStatusComponent implements OnInit {
  @Input() userNewContracrtStatus: any;

  @ViewChild('allContract',{static: false}) allContract: BsModalComponent;

  constructor() { }

  ngOnInit() {
  }

}
